<table class="es-batch-items">
  <thead>
    <tr class="es-batch-item-header">
      <th class="es-batch-item-header-checkbox">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="es-batch-item-all"
            [disabled]="isAllInvalid"
            [ngModel]="isAllChecked"
            (ngModelChange)="isCheckedAllChange.emit($event)"
          />
          <label class="custom-control-label" for="es-batch-item-all">
            <span class="invisible">all</span>
          </label>
        </div>
      </th>
      <th class="es-batch-item-header-ref-number">
        {{ "LABELS.REFERENCE_NUMBERS" | translate }}
      </th>
      <th class="es-batch-item-header-files">
        {{ "FILES" | translate }}
      </th>
      <th class="es-batch-item-header-bl">
        {{ "DOCUMENT_TYPE.BILL_OF_LADING" | translate }}
      </th>
      <th class="es-batch-item-header-seller">{{ "LABELS.SELLER" | translate }}</th>
      <th class="es-batch-item-header-goods-value">{{ "LABELS.GOODS_VALUE" | translate }}</th>
      <th class="es-batch-item-header-actions">
        <div class="es-batch-item-header-actions-wrapper">
          <span>{{ "TOTAL_CONFIRMED_ES" | translate }}:</span>
          <span class="es-batch-item-header-actions-count">{{ checkedItemIds.length }}</span>
        </div>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr
      class="es-batch-item"
      [ngClass]="{
        'es-batch-item-is-checked': isChecked(es.id),
        'es-batch-item-is-checked-next': isCheckedNext(i),
        'es-batch-item-is-last': last
      }"
      *ngFor="let es of esItems; let last = last; let i = index"
    >
      <td class="es-batch-item-checkbox">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="es-batch-item-{{ es.referenceNumber }}"
            [disabled]="!es.valid"
            [ngModel]="isChecked(es.id)"
            (ngModelChange)="isCheckedChange.emit({ id: es.id, checked: $event })"
          />
          <label class="custom-control-label" for="es-batch-item-{{ es.referenceNumber }}">
            <span class="invisible">.</span>
          </label>
        </div>
      </td>
      <td class="es-batch-item-ref-number">
        <div class="es-batch-item-ref-number-container">
          <div class="es-batch-item-ref-number-icon">
            <img *ngIf="es.transportationMode === enumESTransportationMode.AIR" class="icon-type" src="/assets/icons/icon_plain.svg" />
            <img *ngIf="es.transportationMode === enumESTransportationMode.OCEAN" class="icon-type" src="/assets/icons/icon_vessel.svg" />
            <img *ngIf="es.transportationMode === enumESTransportationMode.RAIL" class="icon-type" src="/assets/icons/rail.svg" />
            <img *ngIf="es.transportationMode === enumESTransportationMode.TRUCK" class="icon-type" src="/assets/icons/icon_truck_md.svg" />
          </div>
          {{ es.referenceNumber }}
        </div>
      </td>
      <td class="es-batch-item-files">
        <div
          class="es-batch-item-files-count"
          [ngClass]="{ 'es-batch-item-files-count-valid': isFilesValid(es) }"
          (click)="review.emit(es.id)"
        >
          <div class="es-batch-item-files-count-number">{{ filesCount(es.id) }}</div>
          <div class="es-batch-item-files-count-icon"></div>
        </div>
      </td>
      <td class="es-batch-item-bl">
        <div *ngFor="let shipment of es?.shipments">
          <span class="mr-1" *ngIf="!!shipment?.masterBill">{{ shipment?.masterBill?.carrier }}{{ shipment?.masterBill?.number }}</span>
          <span *ngIf="!!shipment?.houseBill">{{ shipment?.houseBill?.carrier }}{{ shipment?.houseBill?.number }}</span>
        </div>
      </td>
      <td class="es-batch-item-seller">
        <div *ngFor="let shipment of es?.shipments">
          {{ shipment?.seller?.name }}
        </div>
      </td>
      <td class="es-batch-item-goods-value">{{ es.goodsValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</td>
      <td class="es-batch-item-actions">
        <button type="button" class="es-batch-item-actions-review" (click)="review.emit(es.id)">
          <div class="es-batch-item-actions-review-inner">
            <span>{{ "LABELS.REVIEW" | translate }}</span>
            <img class="ml-2" src="assets/icons/icon_arrow_right_green.svg" />
          </div>
        </button>
      </td>
    </tr>
  </tbody>
</table>
